module.exports = __webpack_public_path__ + "img/bg_pop.d1af4238.png";